import {Injectable, Optional} from '@angular/core';
import {ISalesConciergeHttpService} from './sales-concierge.service.interface';
import {SalesConciergeExistingContactRequest, SalesConciergeRequest} from '../models/sales-concierge-request.model';
import {SalesConciergeContactType} from '../enums/sales-concierge-contact-type.enum';
import {firstValueFrom} from 'rxjs';
import {UtilityService} from '../../../../../../shared/services/utility.service';
import {BDShared} from '@brother-apps/brother-dealerapp-shared-lib';
import {MyHttpClient} from '../../../../../../shared/services/my-http-client.service';

@Injectable()
export class SalesConciergeHttpService extends ISalesConciergeHttpService {

    private sharedModel: BDShared;

    public constructor(
        @Optional() private appUtilityService: UtilityService
    ) {
        super();
    }

    public async createSalesConciergeRequest(salesConciergeRequest: SalesConciergeRequest): Promise<void> {


        if (!this.appUtilityService) {
            throw new Error('UtilityService is not provided. Please ensure it is injected properly.');
        }


        this.sharedModel = this.appUtilityService?.getUserQueryParamData();

        let isExistingContact = false;
        const existingSalesConciergeRequest = new SalesConciergeExistingContactRequest();

        if (SalesConciergeContactType[salesConciergeRequest.contactType] === SalesConciergeContactType.EXISTING_CONTACT_INFO) {
            isExistingContact = true;
            existingSalesConciergeRequest.contactType = salesConciergeRequest.contactType;
            existingSalesConciergeRequest.customerInfo = salesConciergeRequest.customerInfo;
            existingSalesConciergeRequest.otherIssuesMessage = salesConciergeRequest.otherIssuesMessage;
            existingSalesConciergeRequest.productCountInfo = salesConciergeRequest.productCountInfo;
            existingSalesConciergeRequest.requestNotes = salesConciergeRequest.requestNotes;
            existingSalesConciergeRequest.requestType = salesConciergeRequest.requestType;
        }


       await firstValueFrom(this.httpClient.post(
            `${this.sharedModel?.apiUrl}/v1/salesConcierge/requests`,
            isExistingContact ? existingSalesConciergeRequest : salesConciergeRequest,
            {
                headers: {
                    'Authentication': 'Token ' + this.sharedModel.appPortalSecurityToken

                }
            }
        ));


    }
}

